import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";
import Logo from "../components/Logo";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function WorkerLogin() {
  const nav = useNavigate();
  const { loginWorker } = useAuth();
  const [workerId, setWorkerId] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await loginWorker(workerId, password);
      toast.success("Welcome!");
      nav("/employee");
    } catch (e) {
      const msg = formatErr(e.response?.data?.detail) || "Login failed";
      setErr(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#F4F7F9]">
      <div className="w-full max-w-md">
        <Link
          to="/"
          data-testid="back-home-worker"
          className="inline-flex items-center gap-1 text-sm text-[#475569] hover:text-[#1A3A5C] mb-4"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-slate-100">
          <div className="flex flex-col items-center">
            <Logo size={64} showTagline={false} />
            <h2 className="mt-5 font-serif font-bold text-2xl text-[#2A8A8F]">
              Employee Sign In
            </h2>
            <p className="text-sm text-[#475569] mt-1">
              Mark your daily attendance
            </p>
          </div>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="worker-id">Employee ID</Label>
              <Input
                id="worker-id"
                data-testid="worker-id-input"
                value={workerId}
                onChange={(e) => setWorkerId(e.target.value)}
                placeholder="e.g. ITP001"
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="worker-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {err && (
              <div data-testid="worker-login-error" className="text-sm text-red-600">
                {err}
              </div>
            )}
            <Button
              type="submit"
              disabled={loading}
              data-testid="worker-login-submit"
              className="w-full bg-[#2A8A8F] hover:bg-[#1C6367] text-white h-11"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
